import React, { memo } from "react";

import Highlighter from "react-highlight-words";

/**
 * Renders product field rows from precomputed titleToValue.
 * Returns null when entries are empty (no fallback).
 * Memoized for performance with large product lists.
 *
 * @param {Object} props
 * @param {Object} props.titleToValue - { [fieldTitle]: value } from getProductDisplayData
 * @param {string} [props.searchTerm] - when set, highlights matching text in values
 * @param {string} [props.rowClassName] - BEM class for each field row (e.g. ProductList__FieldRow)
 */
function ProductFieldDisplay({ titleToValue, searchTerm, rowClassName }) {
  const entries = Object.entries(titleToValue || {});

  if (entries.length === 0) {
    return null;
  }

  return (
    <>
      {entries.map(([title, value]) => (
        <div key={title} className={rowClassName}>
          <span className="LinkedFieldTitle">{`${title}:`}</span>
          <span className="LinkedFieldValue">
            {searchTerm ? (
              <Highlighter
                highlightClassName="searchHighlight"
                searchWords={[searchTerm]}
                autoEscape
                textToHighlight={value != null ? String(value) : ""}
              />
            ) : (
              value ?? ""
            )}
          </span>
        </div>
      ))}
    </>
  );
}

export default memo(ProductFieldDisplay);
